import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import icon from '../../icons/create/upload.svg'
import docxIcon from '../../icons/create/document.svg'
import { Modal, Spin } from 'antd'
import { saveImage } from 'api/Project/project'
import { saveDoucment } from 'api/Project/project'
import { getCookie } from 'helper/cookie'
import { uploadDocumentapiPost } from 'api/TaskInbox/checklist'
import {
  CheckCircleOutlined,
  DeleteOutlined,
  CloseCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { deleteFile } from 'api/Project/project'
import loadingIcons from 'icons/three-dots.svg'
import { uniq } from 'lodash'

let datafiles = []
let listId_repeat = []

const Document = (props) => {
  const {
    visible,
    setVisible,
    project_id,
    subtaskId,
    taskId,
    idEditPRJ,
    kind,
    getCheckList,
    getLogList,
    getListFileDoc,
    titleDoc,
    listFile,
  } = props
  const [files, setFiles] = useState([])
  const [files2, setFiles2] = useState([])
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [visibleReplace, setVisibleReplace] = useState(false)
  const [listfile_name, setListfile_name] = useState([])
  const [filename_repeat, setFilename_repeat] = useState([])
  const token = getCookie('access_token_admin')
  let listTypleFile =
    '.pdf,.doc,.docx,.xlsx,.xls,.txt,.zip,.ppt,.rar,.pptx,.jpg,.jpeg,.png,.gif,.csv'
  const documentUpload = async () => {
    if (listId_repeat.length > 0) {
      delete_replace()
    }
    if (kind === 15) {
      for (let index = 0; index < files2.length; index++) {
        const data = new FormData()
        data.append('uploadfile', files2[index])
        data.append('project_id', project_id)
        data.append('sprintflow_id', subtaskId)
        data.append('task_id', taskId)
        data.append('kind', 15)
        try {
          setLoading(true)
          await uploadDocumentapiPost({
            params: data,
            token: token,
          }).then((res) => {
            if (res.status === 200) {
              files2[index].status = true
              getCheckList()
              getLogList()
            } else {
              files2[index].status = false
              getCheckList()
              getLogList()
            }
            setShow(true)
            console.log(res)
          })
        } catch (error) {
          console.log(error)
        }
      }
      setLoading(false)
      await setTimeout(() => {
        setVisible(false)
        setFiles2([])
        datafiles = []
        setShow(false)
      }, 500)
    } else if (kind === 14) {
      for (let index = 0; index < files2.length; index++) {
        const data = new FormData()
        data.append('uploadfile', files2[index])
        data.append('project_id', idEditPRJ)
        data.append('kind', 14) //document
        try {
          setLoading(true)
          await saveDoucment({
            params: data,
            token: token,
          }).then((res) => {
            if (res.status === 200) {
              files2[index].status = true
              getListFileDoc()
            } else {
              getListFileDoc()
              files2[index].status = false
            }
            setShow(true)
            console.log(res)
          })
        } catch (error) {
          files2[index].status = false
          console.log(error)
        }
      }
      setLoading(false)
      await setTimeout(() => {
        setVisible(false)

        setFiles2([])
        datafiles = []
        setShow(false)
      }, 500)
    }
  }
  const delete_replace = () => {
    //checklist upload doc
    if (kind == 15) {
      listId_repeat.map((id) => {
        const data = {
          id: id,
          project_id: project_id,
          kind: kind,
        }
        try {
          deleteFile({
            params: data,
            token: token,
          }).then((response) => {
            console.log(response)
          })
        } catch (error) {
          console.log(error)
        }
      })
    } else {
      // information upload doc
      listId_repeat.map((id) => {
        const data = {
          id: id,
          project_id: idEditPRJ,
          kind: kind,
        }
        try {
          deleteFile({
            params: data,
            token: token,
          }).then((response) => {
            console.log(response)
          })
        } catch (error) {
          console.log(error)
        }
      })
    }
  }
  const showIcons = (status) => {
    if (show === true) {
      if (status === true) {
        return <CheckCircleOutlined className="checkcircleoutlined" />
      } else if (status === false) {
        return <CloseCircleOutlined className="CloseCircleOutlined " />
      } else {
        return <> </>
      }
    }
  }
  const onCancel = () => {
    listId_repeat = []
    setFilename_repeat([])
    setFiles2([])
    datafiles = []
    setShow(false)
    setVisible(false)
  }

  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    multiple: true,
    accept: listTypleFile,
    onDrop: (acceptedFiles) => {
      checkRepeat(acceptedFiles)
      acceptedFiles.map((item) => {
        let checkrepeat = false
        files2.map((item2) => {
          // console.log('ไฟลที่มีอยู่', item2.path)
          // console.log('ไฟล์ใหม่ที่เข้า', item.path)
          if (item2.path == item.path) {
            checkrepeat = true
          }
        })
        if (checkrepeat == true) {
        } else {
          datafiles.push(item)
        }
      })
      setFiles2(datafiles)
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            status,
          }),
        ),
      )
    },
  })

  const handleDelete = (path) => {
    setShow(false)
    const newFile = datafiles.filter((item) => item.path != path)
    datafiles = newFile
    setFiles2(datafiles)
  }
  useEffect(() => {
    setListfile_name([])
    if (listFile.length > 0) {
      listFile?.map((item) => {
        setListfile_name((prevData) => [
          ...prevData,
          {
            id: item.id,
            filename: item.filename,
          },
        ])
      })
    }
  }, [listFile])

  const checkRepeat = (listfile) => {
    listfile_name?.map((file) => {
      listfile?.map((file_upload) => {
        // console.log(file, file_upload.name)
        if (file.filename == file_upload.name) {
          setFilename_repeat((prev) => [...prev, file.filename])
          setVisibleReplace(true)
          setVisible(false)
        }
      })
    })
  }

  const acceptedFileItems2 = (files23) => {
    return files23.map((file) => {
      return (
        <div className="doculist-container" key={file.path}>
          <img src={docxIcon}></img>
          <p>{file.path}</p>
          {showIcons(file.status)}
          <DeleteOutlined
            className="deleteoutlined"
            onClick={() => handleDelete(file.path)}
          />
        </div>
      )
    })
  }
  const cancelReplace = (e) => {
    if (e.currentTarget.id !== 'skip') {
      for (var i = files2.length - 1; i >= 0; i--) {
        for (var j = 0; j < listfile_name.length; j++) {
          if (files2[i] && files2[i].name === listfile_name[j].filename) {
            files2.splice(i, 1)
          }
        }
      }
    }
    setFilename_repeat([])
    setVisibleReplace(false)
    setVisible(true)
  }
  const modalReplaceFile = () => {
    return (
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleReplace}
        okText={'Replace'}
        onOk={handleReplaceFile}
        onCancel={(e) => cancelReplace(e)}
        cancelText={'Skip'}
        cancelButtonProps={{ id: 'skip' }}
      >
        <WarningOutlined className="exclamationCircleOutlined" />
        <h2>Upload file</h2>
        <h4>{`An item named  ${uniq(
          filename_repeat,
        )}  already exists in this location. Do you want to replace it with the one you’re moving?`}</h4>
      </Modal>
    )
  }
  const handleReplaceFile = () => {
    listId_repeat = []
    files2?.map((file) => {
      listfile_name?.map((file_upload) => {
        if (file.name == file_upload.filename) {
          listId_repeat.push(file_upload.id)
        }
      })
    })
    setFilename_repeat([])
    setVisibleReplace(false)
    setVisible(true)
  }

  return (
    <>
      <Modal
        maskClosable={false}
        className="ChecklistModal"
        title={titleDoc !== undefined ? `Document ${titleDoc}` : 'Document'}
        visible={visible}
        onCancel={onCancel}
        okText={'Upload'}
        onOk={documentUpload}
        destroyOnClose={true}
        // cancelButtonProps={{ style: { display: 'none' } }}
        // okButtonProps={{ style: { display: hidden } }}
      >
        <section className="document-upload-container">
          {/* <Spin style={{ position: 'absolute' }} tip="loading..."></Spin> */}
          <h4>Upload Document</h4>
          <aside className="showfile-container">
            <div>{acceptedFileItems2(files2)}</div>
          </aside>
          <div className="layout-uploadModal">
            <div {...getRootProps({ className: 'dropzone-container' })}>
              <input {...getInputProps()} />
              <img src={icon}></img>
              <h4>Drag and drop here</h4>
              <h4>or</h4>
              <h4 className="browse">browse</h4>
            </div>
            <div className={loading ? 'upload-doc-loading-container' : 'active-waite'}>
              <img src={loadingIcons}></img>
            </div>
          </div>
        </section>
        <div className={loading ? 'block-event' : 'active-waite'}></div>
      </Modal>
      {modalReplaceFile()}
    </>
  )
}

export default Document
